var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},_vm._l((_vm.checklist),function(list,i){return _c('checklist-task-list-wrap-items',{key:i,attrs:{"doneStatus":_vm.doneStatus,"ID":_vm.ID,"list":list}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }